export default __webpack_public_path__ + "static/media/cellphone.9a9825de.svg";